import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import DeleteIcon from "@material-ui/icons/Delete";
import { ErrorOutline } from "@material-ui/icons";
import { Button, TableCell, Grid } from "@material-ui/core";
import { EnhancedTable } from "components/Global/Table/EnhancedTable";


const SelectedNoItemGrid = styled(Grid)`
  &&&& {

    padding: 12px;
    background-color: rgb(242, 242, 242);
    font-family: "Roboto Medium", "Roboto Regular", Roboto;
    font-weight: 500;
    font-style: normal;
    font-size: 17px;
    color: rgb(153, 153, 153);
    width: 844px;
  }`;
const NewButton = styled(Button)`
  && {
    margin: 0 0 -4px 4px;
    padding: 8px 8px 0px 2px;
    border-radius: 0;
    color: #2196f3;
    background: none;
    margin-bottom: 19px;
  }
  & span {
    margin-left: 4px;
  }
  &&:hover {
    background: #f6f6f6;
  }
`;
export const VerticalDivider = styled.div`
height: 34px;
border-right: 1px solid #cccccc;
`;

const EmptyListDiv = styled.div`
  && {
    margin-top: 17px,
    margin-bottom: 17px
  }
`;
const StyledErrorOutline = styled(ErrorOutline)`{
  color: red;
}`;

export class GuestTable extends Component {
  tableColumns = (props) => [
    {
      id: 'firstName',
      label: 'Name',
      numeric: false,
      isString: true,
      isDateField: false,
      width: 320,
      cellValueCalculator: guest => `${guest.firstName} ${guest.lastName}`
    },
    {
      id: 'contactcompanyname',
      label: 'Company',
      numeric: false,
      isString: true,
      isDateField: false,
      dataField: 'company'
    },
    {
      id: 'email',
      label: 'Email',
      numeric: false,
      isString: true,
      isDateField: false,
      cellValueCalculator: guest => `${guest.email}`,
      isNotFilterable: true
    },
    {
      id: 'hasNoPermission',
      label: ' ',
      numeric: true,
      isString: false,
      isDateField: false,
      dataField: '',
      isNotFilterable: true,
      cell: ({ data }) => (<TableCell>{data.hasNoPermission && <StyledErrorOutline/> }</TableCell>)
    },
    {
      id: 'actions',
      label: ' ',
      numeric: true,
      isString: false,
      isDateField: false,
      dataField: '',
      isNotFilterable: true,
      cell: ({ data }) => (<TableCell><NewButton variant="contained" onClick={ () => this.props.deleteGuest(data)}><DeleteIcon/></NewButton></TableCell>)
    },
  ];

  render() {
    if(!this.props.records) return null;

    if(this.props.records.length == 0) return (
      <EmptyListDiv>
        <Grid container direction="row" justify="flex-start" alignItems="center" spacing={8} style={{paddingBottom:"8px"}}>
          <SelectedNoItemGrid container item>{`No invited guests. Choose guests to invite above.`}</SelectedNoItemGrid>
        </Grid>
    </EmptyListDiv>
    )
    const tableColumns = this.tableColumns(this.props);
    return (
      <EnhancedTable
        columnDefinitions={tableColumns}
        rows={this.props.records}
        shouldHideConfig={true}
        shouldHideExport={true}
      />
    );
  }
}

GuestTable.propTypes = {
  records: PropTypes.object.isRequired,
  deleteGuestGroup: PropTypes.func.isRequired,
  manageGuestGroup: PropTypes.func.isRequired
};

function mapStateToProps() {
  return {};
}

export default compose(
  connect(
    mapStateToProps,
    {}
  )
)(GuestTable);
